import { PluginKey, type PluginsState } from '@databases/plugins';

import { NoOpPreviewPanelAFMBridge } from '@canvas/databases-bridge-api';

import { type ModeConfig } from '../types';
import { buildDefaultSelectionFeatures } from '../utils/build-default-selection-features';
import { createBaseModeConfig } from '../utils/create-base-mode-config';

import { initNativeEmbedEditorPluginStartup } from './init-native-embed-editor-plugin-startup';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => true,
  [PluginKey.COMMENTS]: () => true,
  [PluginKey.CONTEXT_MENU]: () => true,
  [PluginKey.EDIT_CONTENT]: () => true,
  [PluginKey.QUICK_CALCULATIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => true,
};

/**
 * Mode config for native embed editor plugin.
 * Uses the same selection features as default mode.
 */
export function createNativeEmbedEditorPluginModeConfig(): ModeConfig {
  return createBaseModeConfig({
    plugins: pluginsState,
    buildSelectionFeatures: buildDefaultSelectionFeatures,
    buildStartupModules: () => [initNativeEmbedEditorPluginStartup],
    dependencies: {
      PreviewPanelAFMBridge: () => new NoOpPreviewPanelAFMBridge(),
    },
  });
}
